/** Canonical channel key: salesChannelId when present, legacy name fallback. */
export const getChannelEntryId = (channel) => {
  if (!channel) return null;
  if (channel.salesChannelId) return String(channel.salesChannelId);
  return channel.name ?? null;
};

export const matchesChannelId = (channel, channelId) => {
  if (!channel || channelId == null) return false;
  const normalizedChannelId = String(channelId);
  if (channel.salesChannelId && String(channel.salesChannelId) === normalizedChannelId) {
    return true;
  }
  if (channel.salesChannel && String(channel.salesChannel) === normalizedChannelId) {
    return true;
  }
  return Boolean(channel.name && String(channel.name) === normalizedChannelId);
};

/** Listing channel id from API listing document. */
export const getListingChannelId = (listing) => {
  if (!listing) return null;
  if (listing.salesChannelId) return String(listing.salesChannelId);
  return listing.salesChannel || null;
};
